import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import DropdownFormField from '../../util/form/DropdownFormField';
import { AddButton } from '../../util/buttons';
import userAccessProjectParticipationsService from '../../services/user_access_project_participations.service';
import userAccessBusinessUnitParticipationsService from '../../services/user_access_business_unit_participations.service';
import ReactSelector from '../../util/form_fields/ReactSelector';
import claimProjectReportsListsService from '@rd-web-markets/shared/dist/services/lists/claim_groups/claim_project_reports_lists.service';
export default function UserProjectAccess(_ref) {
  let {
    userAccess,
    company,
    claimGroup,
    setClaimGroup,
    loading,
    setLoading
  } = _ref;
  const {
    t
  } = useTranslation();
  const [selectedAdditionalAccessType, setSelectedAditionalAccessType] = useState(null);
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [projectDefaultValuesForSelector, setProjectDefaultValuesForSelector] = useState([]);
  const [fetchProjects] = claimProjectReportsListsService.useFetchProjects(claimGroup.id);
  const searchForMoreProjectOptions = useRef(null);
  const [selectedOptionForProjectsSelector, setSelectedOptionForProjectsSelector] = useState(null);
  const createUserAccessProjectParticipation = userAccessProjectParticipationsService.useCreateUserAccessProjectParticipationFromClaimGroup(claimGroup, setClaimGroup, setLoading);
  const createUserAccessBusinessUnitParticipation = userAccessBusinessUnitParticipationsService.useCreateUserAccessBusinessUnitParticipationFromClaimGroup(claimGroup, setClaimGroup, setLoading);
  const getSelectableProjects = function (projects, participations) {
    let projectSearchValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
    return projects.filter(project => !participations.some(participation => participation.claim_project_report.id === project[projectSearchValue]));
  };
  const createParticipation = async () => {
    if (selectedBusinessUnit) {
      createUserAccessBusinessUnitParticipation(userAccess, selectedBusinessUnit.id);
    } else if (selectedProject) {
      const newProjectUserAccesses = await createUserAccessProjectParticipation(userAccess, selectedProject.id);
      const newDefaultOptions = getSelectableProjects(projectDefaultValuesForSelector, newProjectUserAccesses, 'value');
      setProjectDefaultValuesForSelector([...newDefaultOptions]);
      setSelectedOptionForProjectsSelector(null);
    }
  };
  const selectBusinessUnit = id => {
    setSelectedBusinessUnit(company.business_units.find(bu => bu.id === parseInt(id)));
    setSelectedProject(null);
  };
  const selectClaimProjectReport = project => {
    setSelectedBusinessUnit(null);
    setSelectedProject({
      ...selectedProject,
      id: Number(project.value)
    });
    setSelectedOptionForProjectsSelector(project);
  };
  const permissionTypes = [t('project'), t('business_unit')];
  const selectableBusinessUnits = company.business_units.filter(bu => !userAccess.user_access_business_unit_participations.some(participation => participation.business_unit.id === bu.id));
  const fetchAndSetProjectsForSelector = useCallback(async params => {
    const response = await fetchProjects(params);
    const selectableProjects = response.claim_project_reports.filter(project => !userAccess.user_access_project_participations.some(participation => participation.claim_project_report.id === project.id));
    const valuesForSelector = selectableProjects.map(p => {
      return {
        value: p.id,
        label: p.project_name
      };
    });
    if (searchForMoreProjectOptions.current === null) {
      searchForMoreProjectOptions.current = response.pages > 1;
    }
    return valuesForSelector;
  }, [fetchProjects, userAccess.user_access_project_participations]);
  useEffect(() => {
    (async () => {
      const dataForDefaultValues = await fetchAndSetProjectsForSelector({
        page: 1,
        for_pg_search: 'true'
      });
      setProjectDefaultValuesForSelector([...dataForDefaultValues]);
    })();
  }, [fetchAndSetProjectsForSelector]);
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(DropdownFormField, {
    label: "select_permission_type",
    values: permissionTypes,
    onChange: selectedAccessType => setSelectedAditionalAccessType(selectedAccessType?.toLowerCase()?.replaceAll(' ', '_'))
  })), selectedAdditionalAccessType === 'business_unit' && /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, /*#__PURE__*/React.createElement(DropdownFormField, {
    label: "select_business_unit",
    values: selectableBusinessUnits,
    onChange: selectBusinessUnit,
    valueAttributeName: 'id',
    textAttributeName: 'name'
  })), selectedAdditionalAccessType === 'project' && /*#__PURE__*/React.createElement(Col, {
    md: 5,
    className: "d-flex justify-content-center align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-100 pb-5"
  }, /*#__PURE__*/React.createElement(ReactSelector, {
    searchForMoreOptions: searchForMoreProjectOptions.current,
    selectedOption: selectedOptionForProjectsSelector,
    unselectOptionAfterSelect: true,
    searchForMoreOptionsMessage: t('there_are_more_to_load_type_in_to_find_more_results'),
    defaultOptions: projectDefaultValuesForSelector,
    onChange: selectClaimProjectReport,
    fetchAndOptionsSetter: inputValue => fetchAndSetProjectsForSelector({
      page: 1,
      query: `name=${inputValue}`,
      for_pg_search: 'true'
    })
  }))), selectedAdditionalAccessType && /*#__PURE__*/React.createElement(Col, {
    md: 3,
    className: "d-flex justify-content-start align-items-start"
  }, /*#__PURE__*/React.createElement(AddButton, {
    disabled: !selectedBusinessUnit && !selectedProject,
    className: "mt-1",
    loading: loading,
    onClick: createParticipation
  })));
}